export default __webpack_public_path__ + "static/after-support-thumbnail-second-05ce1825fc6302a8a3d28a41be934bf8.png";